<div class="flex w-full gap-6" [class.flex-row]="direction() === 'row'" [class.flex-col]="direction() === 'column'">
  @if (isLoading()) {
    <lepi-spinner class="z-10" />
  } @else {
    @if (items().length < maxlength()) {
      <div class="flex flex-col w-full gap-2">
        <div
          class="p-4 min-w-80 gap-4 border-2 border-base-content/10 border-dashed rounded-lg flex flex-col items-center justify-center hover:border-primary hover:bg-primary-50 transition-all cursor-pointer"
          [ngClass]="{ 'min-h-75': direction() === 'row' }"
          [class]="isDragOvered() ? 'bg-primary-50 border-primary' : 'bg-base-100 border-base-content/10'"
          tabindex="0"
          role="button"
          (click)="onClick()"
          (keydown.enter)="onClick()"
          (keydown.space)="onClick()"
          (dragover)="onDragOver($event)"
          (dragleave)="onDragLeave($event)"
          (drop)="onDragDrop($event)">
          <span class="icon-[mdi--file-upload] w-8 h-8 text-primary"></span>
          <div class="flex flex-col gap-1 text-center">
            <p class="text-sm text-base-content">{{ type() === 'image' ? '사진' : '파일' }}을 선택하거나 끌어다 놓기</p>
            @if (placeholder()) {
              <p class="text-sm text-base-content/60">
                {{ placeholder() }}
              </p>
            }
          </div>
        </div>
        @if (maxlength() > 1) {
          <div class="flex w-full text-sm text-base-content/60">
            <p>{{ items().length }} / {{ maxlength() }}</p>
          </div>
        }
      </div>
    }
    @if (items(); as items) {
      @if (items.length > 0) {
        <div
          cdkDropList
          [cdkDropListData]="items"
          [cdkDropListDisabled]="items.length < 2"
          (cdkDropListDropped)="onDrop($event)"
          class="flex flex-col gap-2 max-h-80 min-w-60">
          @for (item of items; track $index) {
            <div
              cdkDrag
              class="flex w-full justify-between p-2.5 gap-2.5 bg-base-100 border border-base-content/10 rounded-md">
              <div class="flex gap-2.5 items-center">
                @if (type() === 'image') {
                  @if (item.status) {
                    <img
                      [src]="item.url"
                      [alt]="item.filename"
                      class="rounded-md cursor-pointer w-9 h-9"
                      tabindex="0"
                      role="button"
                      (click)="openImage(item.url)"
                      (keydown.enter)="openImage(item.url)"
                      (keydown.space)="openImage(item.url)"
                      (error)="item.status = 'fail'" />
                  } @else {
                    <div class="flex items-center justify-center p-2 border border-base-content/10 rounded-md w-9 h-9">
                      <span class="icon-[mdi--file-image] block w-6 h-6 bg-base-content/80"></span>
                    </div>
                  }
                } @else {
                  <span class="icon-[mdi--file-document] block w-6 h-6 bg-base-content/80"></span>
                }
                <div class="flex flex-col gap-1">
                  <p
                    [ngClass]="{ 'max-w-28': direction() === 'row' }"
                    class="w-full truncate max-w-40 lg:max-w-100 text-sm text-base-content/80">
                    {{ item.filename }}
                  </p>
                </div>
              </div>
              <div class="flex items-center gap-4">
                @if (item.status === 'fail') {
                  <span class="icon-[mdi--alert] w-5 h-5 text-red-500"></span>
                }
                @if (item.status === 'success') {
                  <span class="icon-[mdi--check] w-5 h-5 text-green-500"></span>
                }
                @if (!item.status) {
                  <span class="icon-[mdi--loading] w-5 h-5 text-primary animate-spin"></span>
                }
                @if (item.status) {
                  <button
                    type="button"
                    class="cursor-pointer bg-transparent border-none p-0 flex items-center justify-center"
                    (click)="deleteFile(item.url)">
                    <span class="icon-[mdi--close] w-5 h-5 text-base-content/80"></span>
                    <span class="sr-only">삭제</span>
                  </button>
                }
              </div>
            </div>
          }
        </div>
      }
    }
  }
</div>
<input #inputRef class="hidden" id="app-file-uploader" type="file" multiple [accept]="accept()" />
